import { graphqlClient } from "../../../client";
import mutationDocument from "./updateMemberAddressesMutationExtension.graphql";
import type {
  ContactTypeExtensionAddressesArgs,
  InputUpdateMemberAddressTypeExtension,
  MemberType,
  Mutations,
  MutationsUpdateMemberAddressesExtensionArgs,
} from "@/core/api/graphql/types";

export async function updateMemberAddresses(
  memberId: string,
  addresses: InputUpdateMemberAddressTypeExtension[],
  addressQueryPayload?: ContactTypeExtensionAddressesArgs,
): Promise<MemberType> {
  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "updateMemberAddressesExtension">>,
    MutationsUpdateMemberAddressesExtensionArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: {
        memberId,
        addresses,
      },
      ...addressQueryPayload,
    },
  });
  return data!.updateMemberAddressesExtension;
}
